import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, imageURL } from "../../helper";
import $ from "jquery";
import { Link, withRouter } from "react-router-dom";

export default class ViksitUserdashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      gmail: "",
      phone: "",
    };
    this.viksitbharatList = this.viksitbharatList.bind(this);
  }
  // componentDidMount() {
  //   this.viksitbharatList();
  // }
  loadMoreData = () => {
    this.viksitbharatList(this.state.selectedstate, "loadmore", "");
  };

  enterPressed = (event) => {
    // $("#loader").css({ display: "block" });
    var code = event.keyCode || event.which;
    if (code === 13) {
      $("#loader").css({ display: "block" });
      if (this.input1.value) {
        this.setState({
          gmail: this.input1.value,
        });
        this.viksitbharatList(this.input1.value, this.state.phone);
        // $("#loader").css({ display: "none" });
      }
    }
  };

  phonePressed = (event) => {
    // $("#loader").css({ display: "block" });
    var code = event.keyCode || event.which;
    if (code === 13) {
      $("#loader").css({ display: "block" });
      if (this.input.value) {
        this.setState({
          phone: this.input.value,
        });
        this.viksitbharatList(this.state.gmail, this.input.value);
        // $("#loader").css({ display: "none" });
      }
    }
  };

  viksitbharatList = (gmail, num) => {
    // $("#loader").css({ display: "block" });
    var ref = this;
    var form = new FormData();
    form.append("action", "vbauserdetail");
    form.append(
      "token",
      "92f5603df5ef0772e0b2dcf149c33e53333cc6bfe4ae91beca97196ed5a9ac4201885cff081adb53b9661503c2b3f88a5b7ffc050da02cf749e109cbaf2bac57b92027f897cbf923a5082c2975f484f435ecaf0246a248d2a92f8db5e693778fc63b1f8e2180b9c265f3b1ff0b0cf1cdbeeee7159c4583244e9ceae695ff62930e446b50b6b8d89f991e0224372f4e560d659c13e86220c1001e9436f8ec7ab4a15e2f6b1b7041619bebe7d26650105f63382dd8ecb86ab8642760cfc671cbd99b3d2556bdfe92d9926ae07a6a8a0ff9b8efc10ab9adc11ed4b08a19568e8d60755ff0b199812fae0fa7a2fbab631f80"
    );
    form.append("contact", num ? num : this.state.phone);
    form.append("email", gmail ? gmail : this.state.gmail);

    var requestOptions = {
      method: "POST",
      body: form,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["_resultflag"] == "1" &&
          result["_resultflag"] == 1
        ) {
          ref.setState(
            {
              items: result.data,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    var bread = "Viksit Bharat Ambassador / Dashboard";
    var items = this.state.items;
    return (
      <div>
        <PageTitle
          title="#Viksit Bharat Ambassador"
          bread={bread}
          Count={this.state.post_count}
        />
        <div
          className="row"
          style={{
            "align-items": "center",
            "margin-top": "20px",
            display: "flex",
          }}
        >
          <div className="col-sm-3">
            <input
              className="form-control"
              type="text"
              ref={(input1) => {
                this.input1 = input1;
              }}
              placeholder="Search By Gmail"
              onKeyPress={(e) => {
                this.enterPressed(e);
              }}
            />
          </div>
          <div className="col-sm-3">
            <input
              className="form-control"
              type="text"
              ref={(input) => {
                this.input = input;
              }}
              placeholder="Search By Phone Number"
              onKeyPress={(e) => {
                this.phonePressed(e);
              }}
            />
          </div>
          <div className="col-sm-2">
            <button
              style={{
                "border-radius": "20px",
              }}
              className="btn-success"
              onClick={() => {
                window.location.reload();
              }}
            >
              Clear filters
            </button>
          </div>
        </div>

        <br />
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <table className="table mt-5">
                  <thead className="thead-dark">
                    <tr>
                      {/* <th>User ID</th> */}
                      <th>User Name</th>
                      <th>User Screen Name</th>
                      <th>User Avtar</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Array.isArray(items) &&
                      items.map((value, index) => {
                        return (
                          <tr>
                            {/* <td>{value.user_id ? value.user_id : ""}</td> */}

                            <td>
                              {" "}
                              <Link
                                to={
                                  "/viksitbharatuser/vbadashboard/" +
                                  value.user_id
                                }
                                style={{
                                  color: "black",
                                  "text-decoration": "none",
                                }}
                                target="_blank"
                              >
                                {value.user_name ? value.user_name : ""}
                              </Link>
                            </td>
                            <td>
                              {value.user_screen_name ? value.user_screen_name : ""}
                            </td>

                            <td>
                              {value.user_avatar && (
                                <img
                                  width="200"
                                  height="100"
                                  src={imageURL(value.user_avatar)}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ViksitBharat/ViksitUserdashboard.jsx